jQuery(document).ready(function ($) {
    var clickableImage = document.getElementById('clickme');
    if (clickableImage) {
        clickableImage.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var lightBox = document.getElementById('lightbox')
            lightBox.className = 'open';
            if (!lightBox) {
                return;
            }
        });
    }

    var closeIcon = document.getElementById('close');
    if (closeIcon) {
        closeIcon.addEventListener('click', function () {
            document.getElementById('lightbox').className = '';
        });
    }

    var spaceOutsideImage = document.getElementById('lightbox');
    if (spaceOutsideImage) {
        spaceOutsideImage.addEventListener('click', function (e) {
            if (e.target.id == 'lightbox') {
                document.getElementById('lightbox').className = '';
            }
        });
    }
});

